import { render, staticRenderFns } from "./ShootPhoto.vue?vue&type=template&id=0639c981&"
import script from "./ShootPhoto.vue?vue&type=script&lang=js&"
export * from "./ShootPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports